/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { arr_inArray, htmlspecialchars, split_once } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { update_common_hooks } from './oc-container-compat.js';
import { confirm_box } from './page-modal.js';
import { showErrorToast } from './snackbar.js';
import { jQuery } from '../other/jquery-hooked.js';
import { postToBackend } from './fetch-util.js';
import { mjt } from './i18ntexts.js';


export let ACLEdit = function(window,$) {

	// config
	var m_has_cat_tree = false;				// used in administration area
	var m_select_cat_tree_node_cb = null;	// used in administration area
	var m_cat_tree_1_root = 0,
		m_cat_tree_1_nodes = null,
		m_load_acl_cb = null,
		m_media_info_cb = null,
		m_groups_by_id = {},
		m_users_by_id = {},
		m_show_grouped_by_apply_to = true,			// default: true	- nice and self-descriptive !
		m_show_color_coded = false					// default: false	- requires interaction to understand it - maybe a bit confusing for some users ?
		;

	function prepare_acl_item_list()  {
		$('#acl-item-list table tbody tr[id^=acl-item]').remove();
		$('#acl-item-list .acl-item-ug-show-grouped')
			.off('click')
			.on('click',function() {
				m_show_grouped_by_apply_to = !m_show_grouped_by_apply_to;
				setup_dnd();
				return false;
			});
		$('#acl-item-list .acl-item-ug-show-color-coded')
			.off('click')
			.on('click',function() {
				m_show_color_coded = !m_show_color_coded;
				$('#acl-item-list table').toggleClass('xdata-colored-hover-groups',!!m_show_color_coded);
				return false;
			});
	}

	function setup_dnd() {
		var prev_apply_to = '',
			acl_item_group_num = 0,
			table = $('#acl-item-list table');

		table.toggleClass('xdata-colored-hover-groups',!!m_show_color_coded)
			.find('tr.acl-item-group-start,tr.acl-item-group-end').remove().end()
			.find('tr.acl-item-group-row').removeClass('acl-item-group-row');

		function _close_group( acl_item_group_num ) {
			var group_rows = table.find('tr.acl-item-group-row[acl_item_group_num='+acl_item_group_num+']');
			if( group_rows.length > 0 ) {
				var first_row = group_rows.first(),
					last_row = group_rows.last(),
					first_row_apply_to = first_row.children('.acl-item-col-apply-to'),
					apply_to = first_row_apply_to.attr('apply_to');
				first_row.before('<tr id="acl-item-group-start-'+acl_item_group_num+'" class="acl-item-group-start acl-item-apply-to-'+apply_to.replace('.','-')+' nodrop">'
								+'<td colspan="5" class="acl-item-col-apply-to" apply_to="'+htmlspecialchars(apply_to,true)+'" title="'+htmlspecialchars(first_row_apply_to.attr('title'),true)+'">'+first_row_apply_to.html()+'</td>'
								+'</tr>');
				last_row.after('<tr id="acl-item-group-end-'+acl_item_group_num+'" class="acl-item-group-end acl-item-apply-to-'+apply_to.replace('.','-')+' nodrop">'
								+'<td colspan="5" class="acl-item-col-apply-to" apply_to="'+htmlspecialchars(apply_to,true)+'"></td>'
								+'</tr>');
			} else {
				group_rows.removeClass('acl-item-group-row');
			}
		}

		if( m_show_grouped_by_apply_to ) {
			table.find('tr.acl-item-row').each( function(idx,elem) {
				var row = $(this),
					apply_to = row.children('.acl-item-col-apply-to').attr('apply_to')
					;
				if( apply_to!==prev_apply_to ) {
					_close_group(acl_item_group_num);
					prev_apply_to = apply_to;
					acl_item_group_num ++;
				}
				row.addClass('acl-item-group-row')
					.attr('acl_item_group_num',acl_item_group_num);

			} );
			_close_group(acl_item_group_num);
		}


		table.find('tr.acl-item-row,tr.acl-item-group-start,tr.acl-item-group-end')
			.find('> td.acl-item-col-apply-to')
			.hover(	function() {
				var apply_to = $(this).attr('apply_to');
				table.find('tr.acl-item-row, tr.acl-item-group-start, tr.acl-item-group-end')
					.removeClass('highlighted1')
					.filter('.acl-item-apply-to-'+apply_to.replace('.','-'))
					.addClass('highlighted1');
			}, function() {
			} );
		table.find('tr.acl-item-row > td.acl-item-col-action')
			.hover(	function() {
				var action = $(this).attr('action');
				table.find('tr.acl-item-row')
					.removeClass('highlighted2')
					.filter('.acl-item-action-'+action)
					.addClass('highlighted2');
			}, function() {
			} );


		table
			.tableDnD( {
				onDragClass:'dragging',
				dragHandle:'draghandle',
				onDrop:function(table,row) {
					var acl_id = $('#add-acl-item-form-acl_id').val();
					var cur = $(row),
						cur_id = cur.attr('id'),
						prev = cur.prev(),
						prev_id = prev.attr('id');
					prev_id = prev_id ? parseInt(prev_id.substr(9),10) : 0;

					for( var i=0; i<10000; ++i ) {
						// got it - stop searching through list
						if( prev_id ) break;
						prev = prev.prev(),
						prev_id = prev.attr('id');
						prev_id = prev_id ? parseInt(prev_id.substr(9),10) : 0;
					}

					cur_id = cur_id ? parseInt(cur_id.substr(9),10) : 0;
					if( acl_id && cur_id ) {
						startProgress(true);
						postToBackend( 'json/administration/acls-item_move', 'acl_item_id='+cur_id+'&after_id='+prev_id+'&target_acl_id='+acl_id, function(j) {
							if( j==false ) {
								// failed
								showErrorToast( mjt('acl-edit-error') );
							} else {
								// success
							}
							window.setTimeout(setup_dnd,4);
							stopProgress();
						} );
					}
				},
				onDragStart:function(table,row) {
					//$(table).find('tr.acl-item-row, tr.acl-item-group-start, tr.acl-item-group-end').removeClass('highlighted1 highlighted2');
					$(row).removeClass('highlighted1 highlighted2');
				},
			} );
	}

	function add_acl_item_fragment(id,apply_to,action,allow_deny) {
		if( !id ) return; // ignore undefined & invalid items

		if( action.indexOf(',')!==-1 ) {
			var actions = action.split ? action.split(',') : [action],
				ids = id.split ? id.split(',') : [id];
			var i;
			if( ids.length===actions.length ) {
				for( i=0; i<actions.length; ++i ) add_acl_item_fragment(ids[i],apply_to,actions[i],allow_deny);
			} else {
				for( i=0; i<actions.length; ++i ) add_acl_item_fragment(id,apply_to,actions[i],allow_deny);
			}
			return;
		}

		var ug_option = $('#add-acl-item-apply-to option[value=\''+apply_to+'\']');
		var ug_ti = split_once(ug_option.attr('value')||'group.1','.');
		var ug_type = ug_ti[0];
		var ug_id = ug_ti[1];

		var ug_title = 'ID: '+ug_id+', ';
		if( ug_type==='user' ) ug_title += mjt('user');
		else ug_title += mjt('group');

		var tr_class = 'acl-item-row acl-item-action-'+action
						+' acl-item-apply-to-'+ug_type
						+' acl-item-apply-to-'+ug_type+'-'+ug_id;

		$('#acl-item-list table tbody').append(
			'<tr id="acl-item-'+id+'" class="'+tr_class+'">'
			+ '<td class="acl-item-col-apply-to" title="'+ug_title+'" apply_to="'+ug_type+'.'+ug_id+'">'+htmlspecialchars(ug_option.text())+'</td>'
			+ '<td class="acl-item-col-action" action="'+action+'">'
			+     $('#add-acl-item-action option[value=\''+action+'\']').text()
			+     '<span class="acl-item-col-action-group-num"></span>'
			+ '</td>'
			+ '<td class="acl-item-col-allow-deny">' + ( parseInt(allow_deny,10) ? '<span class="allow">'+mjt('acl-item-allow')+'</span>' : '<span class="deny">'+mjt('acl-item-deny')+'</span>' ) + '</td>'
			+ '<td class="acl-item-col-delete"><span class="delete-link" tabindex="0">'+mjt('delete')+'</span></td>'
			+ '<td class="acl-item-col-drag draghandle" title="'+mjt('acl-item-drag')+'"></td>'
			+ '</tr>' );
		var cat_id = $('#add-acl-item-form-cat_id').val();
		var media_id = $('#add-acl-item-form-media_id').val();
		if( media_id!=0 || cat_id!=m_cat_tree_1_root ) $('#acl-delete').show();
	}

	function create_acl_path( cat_id, media_id ) {
		var ri = []; // = path items in reverse
		if( media_id ) {
			if( m_media_info_cb ) {
				var info = m_media_info_cb(media_id);
				if( typeof info === 'undefined' ) {
					ri.push(media_id);
				} else {
					ri.push(htmlspecialchars(info.title));		//ri[ri.length] = htmlspecialchars(i.title);
					cat_id = info.cat_id;
				}
			} else {
				ri.push(media_id);						//ri[ri.length] = media_id;
			}
		}
		if( cat_id ) {
			var tree1_nodes;
			if( typeof m_cat_tree_1_nodes === 'function' ) tree1_nodes = m_cat_tree_1_nodes();
			else tree1_nodes = m_cat_tree_1_nodes;
			if( cat_id in tree1_nodes ) {
				// if( tree1_nodes.hasOwnProperty(cat_id) ) continue;
				var tc = cat_id;
				while( tc>0 ) {
					var n = tree1_nodes[tc],
						p = n.parent,
						p_known = p==0 || ( p in tree1_nodes ), // is known parent node?
						itm = '',
						nn = htmlspecialchars(n.name);
					if( !p_known ) {
						itm = '<i> (...) &gt; </i>';
						nn = '<i>'+nn+'</i>';
					}
					if( !media_id && tc==cat_id ) itm += nn;
					else itm += '<span class="emph-link" onclick="ACLEdit.load_acl(0,'+tc+',0)" tabindex="0">' + nn + '</span>';
					ri.push(itm);						//ri[ri.length] = itm;
					if( !p_known ) break;
					tc = p;
				}
			} else {
				ri.push( '<span class="emph-link" onclick="ACLEdit.load_acl(0,'+cat_id+',0)" tabindex="0"><i>'+mjt('acl-unknown-category')+' (ID: '+cat_id+')</i></span>' );
				//ri[ri.length] = '<span class="emph-link" onclick="ACLEdit.load_acl(0,'+cat_id+',0)" tabindex="0"><i>'+mjt('acl-unknown-category')+' (ID: '+cat_id+')</i></span>';
			}
		}
		var s = '<b>'+mjt('acl-currently-editing')+'</b>&nbsp; ';
		for( var i=ri.length-1; i>=0; i-- ) {
			if( i < ri.length-1 ) s += ' &gt; ';
			s += ri[i];
		}
		return s;
	}


	function load_acl( acl_id, cat_id, media_id, by_tree_select ) {
		if( m_has_cat_tree ) {
			if( m_select_cat_tree_node_cb ) m_select_cat_tree_node_cb(cat_id,by_tree_select);
		}
		startProgress(true);

		var with_action_texts = true;
		var with_users_and_groups = true;

		var postdata = 'acl_id='+encodeURIComponent(acl_id)+'&cat_id='+encodeURIComponent(cat_id)+'&media_id='+encodeURIComponent(media_id);
		if( with_action_texts ) postdata += '&with_action_texts=1';
		if( with_users_and_groups ) postdata += '&with_users_and_groups=1';
		postToBackend('json/administration/acls-get', postdata, function(j) {

			// get/set acl_id
			$('#add-acl-item-form-acl_id').val( j && j.acl_id ? ''+j.acl_id : '0' );
			$('#add-acl-item-form-cat_id').val( cat_id ? ''+cat_id : '0' );
			$('#add-acl-item-form-media_id').val( media_id ? ''+media_id : '0' );

			var i, action;

			if( with_action_texts ) {
				// get/set actions
				var prev_act_val = $('#add-acl-item-action').val();
				var act_opts = '';
				act_opts += '<optgroup label="'+mjt('acl-system-actions')+'">';
				for( i in j.system_actions ) {
					if( !j.system_actions.hasOwnProperty(i) ) continue;
					action = j.system_actions[i];
					act_opts += '<option value="'+action.id+'">'+htmlspecialchars(action.title)+'</option>';
				}
				act_opts += '</optgroup>';
				act_opts += '<optgroup label="'+mjt('acl-common-action-sets')+'">';
				for( i in j.common_action_sets ) {
					if( !j.common_action_sets.hasOwnProperty(i) ) continue;
					action = j.common_action_sets[i];
					act_opts += '<option value="'+action.id+'">'+htmlspecialchars(action.title)+'</option>';
				}
				act_opts += '</optgroup>';
				act_opts += '<optgroup label="'+mjt('acl-custom-actions')+'">';
				for( i in j.custom_actions ) {
					if( !j.custom_actions.hasOwnProperty(i) ) continue;
					action = j.custom_actions[i];
					act_opts += '<option value="'+action.id+'">'+htmlspecialchars(action.title)+'</option>';
				}
				act_opts += '</optgroup>';
				$('#add-acl-item-action').select2().html(act_opts);
				if( prev_act_val==='' ) {
					var firstValue = $('#add-acl-item-action').find('option').not('[disabled]').first().attr('value');
					$('#add-acl-item-action').val(firstValue).trigger('change.select2');
				} else {
					$('#add-acl-item-action').val(prev_act_val).trigger('change.select2');
				}
			}

			if( with_users_and_groups ) {

				var prev_ug_val = $('#add-acl-item-apply-to').val();
				var u;

				// build hashes from groups and users ...
				m_groups_by_id = {};
				for( i in j.groups ) {
					if( j.groups.hasOwnProperty(i) ) m_groups_by_id[i] = j.groups[i];
				}
				m_users_by_id = {};
				for( i=0; i<j.users.length; ++i ) {
					u = j.users[i];
					m_users_by_id[u[0]] = u;
				}

				var wdg_opts = {
					type: 'group_or_user',
					id: 'add-acl-item-apply-to',
					name: 'apply_to',
					show_ids: true,
					setup_cb: function() {
						$(this).find('.select2-container').css({width:'auto','min-width':'100%','max-width':'100%'});
					},
					entity_source: {
						// pass response data to widget ( contains what is expected: object j.groups and array j.users (with [id,display-name] each) )
						data: j,
					},
				};
				if( prev_ug_val!='' && prev_ug_val!==null )  wdg_opts.value = prev_ug_val;

				// show widget for selecting group or user ...
				$('#add-acl-item-apply-to-widget').mjWidget('destroy').mjWidget(wdg_opts);

			}

			// get and display acl information..
			$('#acl-delete').hide();
			$('#acl-info').html( create_acl_path(cat_id,media_id ) );

			// build items list
			prepare_acl_item_list();
			if( j.acl_items ) {
				for( i in j.acl_items ) {
					if( !j.acl_items.hasOwnProperty(i) ) continue;
					var ai = j.acl_items[i];
					add_acl_item_fragment(ai.acl_item_id,ai.apply_to,ai.action,ai.allow_deny);
				}
			}
			setup_dnd();

			if( m_load_acl_cb ) m_load_acl_cb( j.acl_id, cat_id, media_id );

			stopProgress();
		} );
	}

	function add_acl_item() {
		var form_acl_id = $('#add-acl-item-form-acl_id').val();
		// var cat_id = $('#add-acl-item-form-cat_id').val();
		// var media_id = $('#add-acl-item-form-media_id').val();
		var form = $('#add-acl-item-form');
		var confirm_required = false;
		if( $('#add-acl-item-deny').prop('checked') ) {
			var apply_to = $('#add-acl-item-apply-to').val();
			if( apply_to.substr(0,6)==='group.' ) {
				var gid = apply_to.substr(6);
				if( m_groups_by_id.hasOwnProperty(gid) && arr_inArray('administrator',m_groups_by_id[gid].roles)!==-1 ) confirm_required = true;
			} else if( apply_to.substr(0,5)==='user.' ) {
				var uid = apply_to.substr(5);
				if( m_users_by_id.hasOwnProperty(uid) && (m_users_by_id[uid][3]??false) ) confirm_required = true;
			}
		}
		var _actual_add = function() {
			startProgress(true);
			postToBackend( 'json/administration/acls-item_add', form.serialize(), function(j) {
				if( j==false || j.acl_id==0 ) {
					// failed
					showErrorToast( mjt('acl-edit-error') );
				} else {
					// success
					var action_str = $('#add-acl-item-action').val();
					if( Array.isArray(j.acl_id) && Array.isArray(j.acl_item_id) ) {
						var actions = action_str.split(',');
						for( var i=0; i<j.acl_item_id.length; ++i ) {
							var acl_item_id = j.acl_item_id && j.acl_item_id[i];
							var i_action = actions[i] || actions[0];
							var i_acl_id = j.acl_id && j.acl_id[i];
							$('#add-acl-item-form-acl_id').val(i_acl_id);
							add_acl_item_fragment( acl_item_id, $('#add-acl-item-apply-to').val(), i_action, $('#add-acl-item-allow').prop('checked')?1:0 );
						}
					} else {
						if( form_acl_id == 0 && j.acl_id != 0 ) $('#add-acl-item-form-acl_id').val( ''+j.acl_id );
						add_acl_item_fragment( j.acl_item_id, $('#add-acl-item-apply-to').val(), action_str, $('#add-acl-item-allow').prop('checked')?1:0 );
					}
					setup_dnd();
					update_common_hooks(document);
				}
				stopProgress();
			} );
		};
		if( confirm_required ) {
			confirm_box(mjt('acl-add-admin-deny-confirm-title'),mjt('acl-add-admin-deny-confirm'),function() {
				_actual_add();
			} );
		} else {
			_actual_add();
		}
	}
	function delete_acl_item(id) {
		startProgress(true);
		postToBackend( 'json/administration/acls-item_delete', 'acl_item_id='+id, function(j) {
			if( j==false ) {
				// failed
				showErrorToast( mjt('acl-edit-error') );
			} else {
				// success
				$('#acl-item-list table tbody tr[id=acl-item-'+id+']').remove();
				if( $('#acl-item-list table tbody tr[id^=acl-item-]').length == 0 ) $('#acl-delete').hide();
				setup_dnd();
			}
			stopProgress();
		} );
	}
	function delete_acl() {
		var acl_id = $('#add-acl-item-form-acl_id').val();
		var cat_id = $('#add-acl-item-form-cat_id').val();
		startProgress(true);
		postToBackend( 'json/administration/acls-delete','acl_id='+acl_id+'&cat_id='+cat_id, function(j) {
			if( j==false ) {
				// failed
				showErrorToast( mjt('acl-edit-error') );
			} else {
				// success
				$('#add-acl-item-form-acl_id').val( '0' );
				$('#acl-item-list table tbody tr[id^=acl-item-]').remove();
				$('#acl-delete').hide();
				setup_dnd();
			}
			stopProgress();
		} );
	}

	return {
		configure: function( cat_tree_1_nodes, has_cat_tree, load_acl_cb, media_info_cb, select_cat_tree_node_cb ) {
			m_cat_tree_1_nodes = cat_tree_1_nodes;

			var tree1_nodes;
			if( typeof m_cat_tree_1_nodes === 'function' ) tree1_nodes = m_cat_tree_1_nodes();
			else tree1_nodes = m_cat_tree_1_nodes;

			for( var nid in tree1_nodes ) {
				if( !tree1_nodes.hasOwnProperty(nid) ) continue;
				if( tree1_nodes[nid].parent==0 ) {
					m_cat_tree_1_root = nid;
					break;
				}
			}
			m_has_cat_tree = has_cat_tree;
			m_select_cat_tree_node_cb = select_cat_tree_node_cb;
			m_load_acl_cb = load_acl_cb;
			m_media_info_cb = media_info_cb;
			$('#add-acl-item-form').off().submit( function() {
				add_acl_item();
				return false;
			} );
			$('#acl-delete .delete-link')
				.off('click')
				.on('click',function() {
					confirm_box(mjt('confirm-delete-title'),mjt('confirm-acl-clear'),function() {
						delete_acl();
					});
				});
			$('#acl-item-list table tbody')
				.off('click','.delete-link')
				.on('click','.delete-link',function() {
					var acl_item_id = $(this).closest('tr').attr('id').substr(9);
					confirm_box(mjt('confirm-delete-title'),mjt('confirm-acl-item-delete'),function() {
						delete_acl_item(acl_item_id);
					});
				});
		},
		load_acl: load_acl,
	};

}(window,jQuery); // namespace ACLEdit


window.ACLEdit = ACLEdit; // for <element onlick="ACLEdit.load_acl()".. />
